import FlexColumn from './FlexColumn'

export default FlexColumn
